import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './UserSettings.css';

export default function UserSettings({ user, onLogout }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const upper = (str) => str.toLocaleUpperCase(i18n.language);

  const languages = [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  ];

  return (
    <div className="settings-container">
      <header className="settings-header">
        <span className="settings-back-btn" role="button" tabIndex={0} onClick={() => navigate('/game')} onKeyDown={(e) => e.key === 'Enter' && navigate('/game')}>
          {t('settings.back')}
        </span>
        <span className="settings-header-title">{t('settings.title')}</span>
        <div className="settings-header-spacer" />
      </header>

      <div className="settings-body">
        {/* Account Details */}
        <section className="settings-section">
          <h2 className="settings-section-title">{upper(t('settings.accountDetails'))}</h2>
          <div className="settings-card">
            <div className="settings-row">
              <span className="settings-row-label">{t('settings.username')}</span>
              <span className="settings-row-value">{user?.username || user?.name || '—'}</span>
            </div>
            <div className="settings-row-divider" />
            <div className="settings-row">
              <span className="settings-row-label">{t('settings.email')}</span>
              <span className="settings-row-value">{user?.email || '—'}</span>
            </div>
            {user?.id && (
              <>
                <div className="settings-row-divider" />
                <div className="settings-row">
                  <span className="settings-row-label">{t('settings.accountId')}</span>
                  <span className="settings-row-value settings-row-value-muted">{user.id}</span>
                </div>
              </>
            )}
          </div>
        </section>

        {/* Preferences */}
        <section className="settings-section">
          <h2 className="settings-section-title">{upper(t('settings.preferences'))}</h2>
          <div className="settings-card">
            <div className="settings-row settings-row-column">
              <span className="settings-row-label">{t('settings.language')}</span>
              <div className="lang-options">
                {languages.map((lang) => (
                  <button
                    key={lang.code}
                    className={`lang-option-btn ${i18n.language === lang.code ? 'lang-option-btn-active' : ''}`}
                    onClick={() => i18n.changeLanguage(lang.code)}
                  >
                    <span className="lang-option-flag">{lang.flag}</span>
                    <span className="lang-option-label">{lang.label}</span>
                    {i18n.language === lang.code && <span className="lang-option-check">✓</span>}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Sign Out */}
        <section className="settings-section">
          <button className="settings-signout-btn" onClick={onLogout}>
            {t('settings.signOut')}
          </button>
        </section>
      </div>
    </div>
  );
}
